export const newsTranslation = {
  en: {
    news: "News",
    addNews: "Add News",
    editNews: "Edit News",
    updateNews: "Update News",
    addNewNews: "Add New News",
    titleEN: "Title EN",
    titleAR: "Title AR",
    status: "Status",
    url: "URL",
    descriptionEN: "Description EN",
    descriptionAR: "Description AR",
    searchByNewsTitle: "Search by news title...",
    "Are you sure you want to delete news '{{title}}'?":
      "Are you sure you want to delete news '{{title}}'?",
    actionCannotBeUndone: "This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
    createdAt: "Created at",
    actions: "Actions",
    search: "Search",
  },
  ar: {
    news: "أخبار",
    addNews: "إضافة أخبار",
    editNews: "تحرير الأخبار",
    updateNews: "تحديث الأخبار",
    addNewNews: "إضافة أخبار جديدة",
    titleEN: "العنوان EN",
    titleAR: "العنوان AR",
    status: "الحالة",
    url: "الرابط",
    descriptionEN: "الوصف EN",
    descriptionAR: "الوصف AR",
    searchByNewsTitle: "البحث عن طريق عنوان الخبر...",
    "Are you sure you want to delete news '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف الخبر '{{title}}'؟",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    delete: "حذف",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    search: "بحث",
  },
};
